import { useOnClickOutside } from 'hooks'
import React, { useRef } from 'react'
import { Box } from '@mui/material'

const sx = {
  categories: {
    position: 'absolute',
    top: 80,
    width: '100%',
    padding: 8,
    zIndex: 1000,
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    overflowY: 'auto',
    maxHeight: 220,
    fontSize: '14px'
  },
  span: {
    padding: 10,
    cursor: 'pointer',
    display: 'block',
    color: '#66668F',
    // borderBottom: '1px solid #CCCBD9',
    '&:hover': {
      backgroundColor: '#F4F4F7',
    },
  }
}

const IndustryInfo = ({
  categories,
  setValue,
  dropToDefault,
  style,
  lastSelectedValue,
  setLastValue
}) => {
  const ref = useRef(null)

  useOnClickOutside(ref, () => {
    dropToDefault([])
    setValue('category', lastSelectedValue)
  })

  const action = (item) => {
    dropToDefault([])
    setLastValue && setLastValue(item)
    setValue('category', item)
  }

  if (categories.length === 0) return null

  return (
    //@ts-ignore
    <Box ref={ref} sx={sx.categories} style={style}>
      {categories.map(item => (
        <Box component="span" onClick={() => action(item)} sx={sx.span} key={item}>
          {item}
        </Box>
      ))}
    </Box>
  )
}

export default IndustryInfo
